import React from 'react';

import {ArrowLeftIcon, Button} from '@kit';

import css from './master.module.css';

type SelectedTitleProps = {
	title: string;
	/** подпись кнопки возврата к списку */
	backLabel: string;
	onBack(): void;
};

export const SelectedTitle: React.FC<SelectedTitleProps> = ({title, backLabel, onBack}) => (
	<div className={css.selectedTitle}>
		<Button
			appearance="subtle"
			icon={<ArrowLeftIcon />}
			title={backLabel}
			aria-label={backLabel}
			onClick={onBack}
		/>
		<h2>{title}</h2>
	</div>
);
